import { configService } from "@/settings/api-url";
const actions = {
  action_getLastOrder(context) {
    configService("/orders/not_id?last_order=true").then((response) => {
      context.commit("CURRENT_ORDER", response.data);
    });
  },
  async action_getOrders(
    { commit },
    payload = {
      perPage: 5,
      page: 1,
    }
  ) {
    await configService(`/orders?per_page=${payload.perPage}&page=${payload.page}`).then(
      (response) => {
        if (response.data) {
          if (response.data.orders) {
            commit("ORDERS", response.data.orders);
          }
          if (response.data.meta && response.data.meta.pagination) {
            commit("ORDERS_META", response.data.meta.pagination);
          }
        }
      }
    );
  },
  action_getCurrentOrder({ commit }, data) {
    configService(`/orders/${data}`).then((res) => {
      const { data } = res;
      commit("CURRENT_ORDER", data);
      commit("LOGS", data.logs);
      // dispatch('action_evaulateOrder')
      return res;
    });
  },
  action_getTransaction({ commit }, data) {
    configService(`/transactions/${data}`).then((res) => {
      const { data } = res;
      commit("CURRENT_ORDER_PAYMENT", data);
      return res;
    });
  },
  action_evaulateOrder({}) {},
  action_notifyOrderAction({ state }) {
    if ("Notification" in window) {
      if (Notification.permission === "granted") {
        let options = {
          icon: "https://m.enlau.co/missing/logo-marca-morado.png",
          body: this.$t(state.currentOrder.status + ".message." + state.currentOrder.commerce.type),
        };
        // eslint-disable-next-line
        let notification = new Notification(
          `ID ${state.currentOrder.id} - ${state.$t(
            state.currentOrder.status + ".state." + state.currentOrder.commerce.type
          )}`,
          options
        );
      } else if (Notification.permission !== "denied") {
      }
    }
  },
};

export default actions;
